<template>
  <div class="page-bg">
    <div class="page-main">
      <!-- 顶栏：返回按钮 + 标题 -->
      <PageHeader title="调理方案笺" @back="goBack" />

      <!-- 方案笺卡片列表 -->
      <div class="card" v-for="(item, index) in prescriptions" :key="index">
        <h2 class="pres-name">名称：{{ item.name }}</h2>

        <div class="img-wrapper">
          <div :class="['print-div', 'img-print' + index]">
            <img :src="item.imageUrl" />
          </div>
        </div>

        <div class="btn-container">
          <button class="btn-action btn-print" @click="print(index)">打印</button>
          <button
            class="btn-action btn-ship"
            @click="fulfillment(index, item.name)"
            v-if="item.status == '0' || item.status == '1'"
          >{{ item.status == "0" ? "点击配送" : "配送详情" }}</button>
          <button class="btn-action btn-close" @click="close">关闭窗口</button>
        </div>

        <div class="divider"></div>
      </div>

      <!-- 空状态 -->
      <div v-if="loading" class="page-empty">
        <i class="el-icon-loading"></i>
      </div>
      <div v-else-if="prescriptions.length === 0" class="page-empty">
        <i class="el-icon-document-remove"></i>
        <div class="empty-text">未找到调理方案图片</div>
        <el-button type="primary" @click="goBack">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/widgets/PageHeader.vue";

export default {
  components: { PageHeader },
  data() {
    return {
      prescriptions: [],
      loading: false,
      visitRecordId: "",
      prescriptionType: "",
      recordType: "",
    };
  },
  created() {
    this.visitRecordId = this.$route.query.visitRecordId || "";
    this.prescriptionType = this.$route.query.prescriptionType || "";
    this.recordType = this.$route.query.recordType || "";
    this.loadPrescriptions();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    close() {
      this.$router.replace("/");
    },
    // 获取调理方案笺图片
    loadPrescriptions() {
      if (!this.visitRecordId) {
        this.$message.warning("缺少就诊记录编号，无法加载方案笺");
        return;
      }
      this.loading = true;
      var params = { visitRecordId: this.visitRecordId };
      // 读取 URL 中的可选筛选参数
      if (this.recordType) params.recordType = this.recordType;
      if (this.prescriptionType) params.prescriptionType = this.prescriptionType;
      this.wjtHttp.post(
        this,
        "/api/health/v2/prescription/image/filter",
        params,
        false,
        (res) => {
          this.loading = false;
          var data = res.data;
          if (data.code == 200) {
            this.prescriptions = data.data || [];
          } else {
            this.$message({
              message: data.msg && data.msg.length > 0 ? data.msg : "出方异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
          this.loading = false;
        }
      );
    },
    print(index) {
      var newstr = document.getElementsByClassName("img-print" + index)[0].innerHTML;
      console.log(newstr);
      document.body.innerHTML = newstr;
      var oldstr = document.body.innerHTML;
      window.print();
      document.body.innerHTML = oldstr;
      window.location.reload();
    },
    // 去配送 / 配送详情（参照 prescription 的配送逻辑，超微方沿用 ChaoweiPrescriptionPage 已组装的配送数据）
    fulfillment(index, name) {
      console.log(index, name);
      var item = this.prescriptions[index];
      if (!item) {
        this.$message.warning("未找到该方案数据");
        return;
      }
      if (item.status == 1) {
        // 已配送：跳转配送订单详情
        this.$router.push({
          path: "/fulfillmentOrder",
          query: {
            orderId: item.deliveryOrderId,
          },
        });
        return;
      }
      // 代理商演示账号禁止配送下单
      var userInfo = this.$store.getters.getUserInfo;
      var roles = userInfo && userInfo.roles ? userInfo.roles : [];
      var isAgentDemo = false;
      for (var i = 0; i < roles.length; i++) {
        if (roles[i] == "level1" || roles[i] == "level2") {
          isAgentDemo = true;
          break;
        }
      }
      // if (isAgentDemo) {
      //   this.$message.warning("当前为演示账号，配送下单功能暂未开放");
      //   return;
      // }
      this.$confirm(
        `此调理人共有${this.prescriptions.length}个调理方案，您正在确认配送${name}`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          // 以 ChaoweiPrescriptionPage 构造好的 prescription（含超微方 type）为基础
          var prescription = JSON.parse(sessionStorage.getItem("prescription") || "{}");
          // 用方案笺接口返回的 item 补充/修正配送所需字段
          if (!prescription.type || prescription.type.indexOf("_superfine_prescription") === -1) {
            prescription.type = item.type && item.type.indexOf("_superfine_prescription") !== -1 ? item.type : (prescription.type || "");
          }
          prescription.visitRecordId = prescription.visitRecordId || this.visitRecordId;
          prescription.startDate = prescription.startDate || item.startDate || "";
          prescription.endDate = prescription.endDate || item.endDate || "";
          prescription.name = prescription.name || item.name || "";
          prescription.status = "0";
          prescription.deliveryOrderId = "";
          prescription.imageUrl = item.imageUrl || prescription.imageUrl || "";
          prescription.prescriptionNo = "";
          sessionStorage.setItem("prescription", JSON.stringify(prescription));
          // 超微方明细与调理人信息沿用（由 ChaoweiPrescriptionPage 透传，供 fulfillmentConfirm 回填）
          var superfinePane = sessionStorage.getItem("superfinePane");
          if (!superfinePane) {
            sessionStorage.setItem("superfinePane", JSON.stringify({}));
          }
          var superfinePatient = sessionStorage.getItem("superfinePatient");
          if (!superfinePatient) {
            sessionStorage.setItem("superfinePatient", JSON.stringify({}));
          }
          this.$store.commit("updateFulfillmentConfirmData", {});
          this.$router.push({
            path: "/fulfillmentConfirm",
            query: {
              index: index,
              name: name,
            },
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消配送",
          });
        });
    },
  },
};
</script>

<style scoped>
/* ===== 页面背景 ===== */
.page-bg {
  min-height: 100vh;
  background: radial-gradient(circle at 78% 18%, rgba(235, 220, 173, 0.28), transparent 28%),
    linear-gradient(120deg, #eef8f2 0%, #f7fbf8 48%, #eef7f1 100%);
  font-family: 'Noto Sans SC', system-ui, sans-serif;
  color: #082b1c;
}

.page-main {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 24px;
}

/* ===== 卡片 ===== */
.card {
  background: #fff;
  border: 1px solid rgba(0, 70, 43, 0.1);
  border-radius: 30px;
  padding: 32px 40px;
  box-shadow: 0 14px 35px rgba(25, 70, 43, 0.08);
  margin-bottom: 28px;
}

/* ===== 方案名称 ===== */
.pres-name {
  font-size: 22px;
  font-weight: 700;
  color: #18334b;
  margin: 0 0 20px 0;
  text-align: center;
}

/* ===== 图片区 ===== */
.img-wrapper {
  width: 100%;
  max-width: 984px;
  margin: 0 auto;
  overflow: hidden;
}

.print-div {
  width: 100%;
}

.print-div img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 页码 ===== */
.page-num {
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  margin-top: 20px;
}

/* ===== 按钮行 ===== */
.btn-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 36px;
  margin-top: 32px;
}

.btn-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 150px;
  height: 44px;
  padding: 0 28px;
  border: none;
  border-radius: 9999px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
}

/* 打印方案笺 */
.btn-print {
  background: #20863F;
  color: #fff;
  box-shadow: 0 10px 22px rgba(44, 132, 82, 0.22);
}

.btn-print:hover {
  background: #257648;
  transform: translateY(-1px);
}

/* 配送 */
.btn-ship {
  background: #f59a32;
  color: #fff;
  box-shadow: 0 10px 22px rgba(245, 154, 50, 0.22);
}

.btn-ship:hover {
  background: #ee8b1e;
  transform: translateY(-1px);
}

/* 关闭窗口 */
.btn-close {
  background: #fff;
  color: #617168;
  border: 1px solid #d6e5dc;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.btn-close:hover {
  border-color: #bbdac8;
  background: #f3fbf6;
  color: #1c7447;
}

/* ===== 分割线 ===== */
.divider {
  height: 1px;
  width: 100%;
  background-color: #e2e8f0;
  margin-top: 32px;
}

/* ===== 空状态 ===== */
.page-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 120px 0;
  color: #999999;
  font-size: 40px;
}

.empty-text {
  margin: 12px 0 20px;
  font-size: 14px;
  color: #555555;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .page-main {
    padding: 24px 16px;
  }

  .card {
    padding: 20px 16px;
    border-radius: 20px;
  }

  .page-title {
    font-size: 20px;
  }

  .pres-name {
    font-size: 18px;
  }

  .btn-container {
    gap: 16px;
  }

  .btn-action {
    min-width: 120px;
    height: 40px;
    font-size: 14px;
    padding: 0 20px;
  }
}
</style>
